export interface PageableData {
  totalRecords: number;
  page: number;
  count: number;
}

export const initialPageableData: PageableData = {
  totalRecords: 0,
  page: 0,
  count: 10,
} as const;

export interface DataSource<T> extends PageableData {
  rawData?: T;
}
